"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var react_router_dom_1 = require("react-router-dom");

var data_1 = require("../data");

var VizOverviewPage =
/** @class */
function (_super) {
  __extends(VizOverviewPage, _super);

  function VizOverviewPage(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      currentViz: null
    };
    return _this;
  }

  VizOverviewPage.prototype.componentDidMount = function () {
    this.setupCurrentViz();
  };

  VizOverviewPage.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setupCurrentViz();
    }
  };

  VizOverviewPage.prototype.render = function () {
    return this.state.currentViz && React.createElement(semantic_ui_react_1.Container, null, this.renderOverview(this.state.currentViz), this.renderExamples(this.state.currentViz.examples));
  };

  VizOverviewPage.prototype.renderOverview = function (viz) {
    return React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      columns: 2
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement("img", {
      alt: "icon for " + viz.name,
      src: "assets/icons/" + viz.name.toLocaleLowerCase() + "-icon.png",
      style: {
        height: '150px',
        padding: '20px'
      }
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left'
    }, React.createElement(semantic_ui_react_1.Header, {
      as: 'h1'
    }, viz.name, React.createElement(semantic_ui_react_1.Header.Subheader, null, viz.authors.join(', '))), React.createElement(React.Fragment, null, React.createElement("p", null, viz.detailedSummary), React.createElement(semantic_ui_react_1.List, null, React.createElement(semantic_ui_react_1.List.Item, null, "applicable data: ", viz.relevantData), React.createElement(semantic_ui_react_1.List.Item, null, "compatible with: ", viz.compatibility.join(', ')), React.createElement(semantic_ui_react_1.List.Item, null, "citation(s):", ' ', viz.citations.map(function (citation, index) {
      return React.createElement(React.Fragment, {
        key: viz.name.toLocaleLowerCase() + "-citation-" + index
      }, citation.fullCitation, " (", React.createElement("a", {
        href: citation.link
      }, "link"), ")");
    })), React.createElement(semantic_ui_react_1.List.Item, null, "version: ", viz.repo.version, " (last updated ", viz.repo.lastUpdate, "),", React.createElement("a", {
      href: viz.repo.link
    }, " github link")), React.createElement(semantic_ui_react_1.List.Item, null, React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'right'
    }, React.createElement(semantic_ui_react_1.Button, {
      basic: true,
      icon: true,
      labelPosition: 'right'
    }, React.createElement(react_router_dom_1.Link, {
      to: {
        pathname: '/dataset',
        search: "?viz=" + viz.name.toLocaleLowerCase()
      }
    }, "launch " + viz.name), React.createElement(semantic_ui_react_1.Icon, {
      name: 'external alternate'
    }))))))));
  };

  VizOverviewPage.prototype.renderExamples = function (examples) {
    var _this = this;

    var panels = [{
      content: {
        content: React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Divider, null), React.createElement(semantic_ui_react_1.Grid, {
          centered: true,
          columns: 1,
          container: true,
          divided: 'vertically',
          style: {
            padding: '10px 0'
          }
        }, examples.map(function (example, index) {
          return React.createElement(semantic_ui_react_1.Grid.Row, {
            columns: 2,
            key: "viz-example-" + index
          }, _this.renderExampleEntry(example));
        })))
      },
      key: 'examples',
      title: 'example stories'
    }, {
      content: 'coming soon!',
      key: 'learn',
      title: 'learn'
    }];
    return React.createElement(semantic_ui_react_1.Accordion, {
      panels: panels,
      defaultActiveIndex: 0
    });
  };

  VizOverviewPage.prototype.renderExampleEntry = function (example) {
    return React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement("img", {
      src: example.icon,
      alt: example.name + " icon",
      style: {
        height: '75px',
        width: '75px'
      }
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left',
      width: 8
    }, React.createElement(semantic_ui_react_1.Header, null, example.name), React.createElement("p", null, example.summary)), React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'right'
    }, React.createElement(semantic_ui_react_1.Button, {
      basic: true,
      icon: true,
      labelPosition: 'right'
    }, React.createElement(react_router_dom_1.Link, {
      to: example.link
    }, 'launch example'), React.createElement(semantic_ui_react_1.Icon, {
      name: 'external alternate'
    }))));
  };

  VizOverviewPage.prototype.setupCurrentViz = function () {
    var params = new URLSearchParams(this.props.location ? this.props.location.search : ''); // tslint:disable-next-line:no-backbone-get-set-outside-model

    var vizName = params.get('name');

    if (vizName === data_1.VizData.spring.name.toLocaleLowerCase()) {
      this.setState({
        currentViz: data_1.VizData.spring
      });
    } else if (vizName === data_1.VizData.tfjsTsne.name.toLocaleLowerCase()) {
      this.setState({
        currentViz: data_1.VizData.tfjsTsne
      });
    } else if (vizName === data_1.VizData.anatomogram.name.toLocaleLowerCase()) {
      this.setState({
        currentViz: data_1.VizData.anatomogram
      });
    }
  };

  return VizOverviewPage;
}(React.Component);

exports.VizOverviewPage = VizOverviewPage;